import { UserType } from '../../models/graphqlTypes'
import { useMe } from './useMe'

export const useUserType = (): UserType | undefined => {
  const { data: { me } = {} } = useMe({
    fetchPolicy: 'cache-only',
  })
  return me?.userType
}
